import moment from 'moment';

import { datePickerConstants, formFieldsConstants } from '@elab/core/utils/constants';

require('moment/min/locales.min');

const formatFromISO = (date, formatTo = 'dddd D MMMM') => moment(date).format(formatTo);
const formatToISO = (date, formatFrom = datePickerConstants.DEFAULT_FORMAT) =>
    moment(date, formatFrom).format();

const formatToCustom = (date, formatTo, formatFrom = datePickerConstants.DEFAULT_FORMAT) => {
    const isFormatted = moment(date, formatTo).format(formatTo) === date;

    return isFormatted ? date : moment(date, formatFrom).format(formatTo);
};

const getLocalized = (() => {
    let localized;
    return () => {
        localized =
            localized ||
            moment()
                .locale(document.documentElement.lang || 'en')
                .localeData();
        return localized;
    };
})();

function parseDeliveryTimeSlot(slot) {
    const { date, from: timeFrom, to: timeTo } = slot;
    const slotDate = moment(date, 'YYYY-MM-DD');
    const weekday = getLocalized().weekdays(slotDate);
    const month = getLocalized().months(slotDate);
    const dayOfMonth = slotDate.date();

    return { month, weekday, dayOfMonth, timeFrom, timeTo };
}

function getDayOfTheWeek(date = null) {
    if (date) {
        return moment(date).isoWeekday();
    }
    return moment().isoWeekday();
}

function dateToString(date, formatter = formFieldsConstants.defaultDateFormatter) {
    return moment(date)
        .locale(document.documentElement.lang || 'en')
        .format(formatter);
}

const generateArrayOfConsecutiveNumbers = (start = 1, end = 0) =>
    Array(end - start + 1)
        .fill(0)
        .map((_, i) => i + start);

// getPartialFormattedDate('2010-MM-DD', 'DD-MM-YYYY') => 'DD-MM-2010'
const getPartialFormattedDate = (dateInISO, formatTo) => {
    const [year, month, day] = dateInISO.split('-');
    return formatTo
        .replace(datePickerConstants.FORMAT_PANELS.YEARS, year)
        .replace(datePickerConstants.FORMAT_PANELS.MONTHS, month)
        .replace(datePickerConstants.FORMAT_PANELS.DAYS, day);
};

const getDateByChunkOfFormat = (dateInISO, chunkOfFormat) => {
    const chunkIndex = getDateChunkIndex(chunkOfFormat);
    return dateInISO.split('-')[chunkIndex];
};

const isDateValid = date => moment(date, datePickerConstants.DEFAULT_FORMAT, true).isValid();

const getDateChunkIndex = chunkName => {
    return {
        [datePickerConstants.FORMAT_PANELS.YEARS]: 0,
        [datePickerConstants.FORMAT_PANELS.MONTHS]: 1,
        [datePickerConstants.FORMAT_PANELS.DAYS]: 2,
    }[chunkName];
};

export {
    formatToISO,
    formatFromISO,
    formatToCustom,
    parseDeliveryTimeSlot,
    getDayOfTheWeek,
    dateToString,
    generateArrayOfConsecutiveNumbers,
    getPartialFormattedDate,
    getDateByChunkOfFormat,
    isDateValid,
    getDateChunkIndex,
};
